import { render, staticRenderFns } from "./NotificationTemplateCreate.vue?vue&type=template&id=d1d855f6"
import script from "./NotificationTemplateCreate.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports